import { getDriver } from "@/tours/driverInstance";
import router from '@/router'
import demoImgUrl from '@/assets/img/tour/rawMaterialSample.png';

export function rawMaterialListSteps(focusIntoView) {
  const q = (sel) => document.querySelector(sel);
  return [
    {
      element: () => q('[data-tour="dlist.create"]'),
      popover: {
        title: "다음 가이드로 이동",
        side: "center",
        align: "center",
        description: `
          <div style="margin-bottom:32px;"><b>재료정보 등록화면</b>으로 이동합니다.
          </div>
            <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:end;">
              <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
              <button id="go-register" class="driver-popover-next-btn driver-popover-btn">
                이동
              </button>
            </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();
        document.querySelector('#go-register')
          ?.addEventListener('click', () => {
            drv.destroy();
            router.push({ name: 'RawMaterialCreate' ,query: { tour: 'true', view: 'create' } });
          });
      }
    },
  ];
}


export function rawMaterialCreateSteps(focusIntoView) {
  const q = (sel) => document.querySelector(sel);
  return [
    {
      element: () => q('[data-tour="dcreate.left"]'),
      popover: {
        title: "상세정보 설정",
        side: "right",
        align: "start",
        popoverClass: 'driver-theme-bs popover-offset-r',
        description: `
          <div class="ds-tip" style="margin-bottom:32px;">
            <div class="item"><span class="num">1</span><div class="txt">
              <div class="tit">대표 이미지</div>
              <div class="desc">
                재료를 쉽게 구분할 수 있는 사진을 등록합니다. (선택 항목)<br/>
                예) 원자재 포장 사진, 샘플 이미지, 라벨 이미지<br/>
                ※ JPG/PNG 형식, 10MB 이하 권장
              </div>
            </div></div>

            <div class="item"><span class="num">2</span><div class="txt">
              <div class="tit">재료 분류</div>
              <div class="desc">
                등록할 재료가 속하는 분류(카테고리)를 선택합니다.<br/>
                예) 금속류, 플라스틱, 원단, 화학물질 등
              </div>
            </div></div>

            <div class="item"><span class="num">3</span><div class="txt">
              <div class="tit">재료 이름</div>
              <div class="desc">
                재료의 이름을 입력합니다.<br/>
                예) <b>스테인리스강 304</b>, <b>PET 수지</b>, <b>면 원단</b>
              </div>
            </div></div>

            <div class="item"><span class="num">4</span><div class="txt">
              <div class="tit">URN</div>
              <div class="desc">
                EPCIS에서 사용하는 고유 식별자(URN: Uniform Resource Name)를 입력합니다.<br/>
                재료를 추적·관리하기 위한 고유 코드이며, 중복되지 않도록 주의하세요.<br/>
                예) urn:epc:id:sgtin:8808123456.00001
              </div>
            </div></div>

            <div class="item"><span class="num">5</span><div class="txt">
              <div class="tit">원산지 국가</div>
              <div class="desc">
                해당 재료가 생산·출하된 국가를 선택합니다.<br/>
                예) 대한민국, 일본, 독일, 중국
              </div>
            </div></div>

            <div class="item"><span class="num">6</span><div class="txt">
              <div class="tit">유해성 여부</div>
              <div class="desc">
                해당 재료가 유해 물질에 해당하는지 여부를 선택합니다.<br/>
                예) <b>예</b> – 특정 화학물질, <b>아니오</b> – 일반 원자재
              </div>
            </div></div>

            <div class="item"><span class="num">7</span><div class="txt">
              <div class="tit">친환경 여부</div>
              <div class="desc">
                해당 재료가 친환경 인증을 받았거나 친환경 특성을 가지는 경우 선택합니다.<br/>
                예) 재활용 원자재, 친환경 섬유, 저탄소 공정 제품
              </div>
            </div></div>

            <div class="item"><span class="num">8</span><div class="txt">
              <div class="tit">설명</div>
              <div class="desc">
                재료에 대한 상세 설명을 입력합니다.<br/>
                예) <b>내식성이 뛰어나 주방기구 및 의료기기 제작에 사용</b>,<br/>
                <b>강도가 높고 가공성이 우수하여 자동차 부품에 적합</b>
              </div>
            </div></div>
          </div>
          <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:end;">
            <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
            <button id="auto-input" class="driver-popover-custom-btn driver-popover-btn">
              다음
            </button>
          </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();

        const sleep = (ms) => new Promise(r => setTimeout(r, ms));
        const typeInto = async (el, text, delay = 25) => {
          if (!el) return;
          el.focus();
          el.value = '';
          el.dispatchEvent(new Event('input', { bubbles: true }));
          for (const ch of text) {
            el.value += ch;
            el.dispatchEvent(new Event('input', { bubbles: true }));
            await sleep(delay);
          }
          el.blur();
        };

        const scopeLeft = '[data-tour="dcreate.left"]';
        const $name    = document.querySelector(`${scopeLeft} input[placeholder="예: 스테인리스강 304"]`);
        const $urn     = document.querySelector(`${scopeLeft} input[placeholder^="예: urn:epc:id:..."]`);
        const $address = document.querySelector(`${scopeLeft} input[placeholder="국가 선택"]`);
        const $memo    = document.querySelector(`${scopeLeft} textarea[placeholder="재료 설명을 입력하세요."]`);

        const setDemoImage = async (url) => {
          const res = await fetch(url);
          const blob = await res.blob();
          const name = (url.split('/').pop() || 'demo.jpg');
          const file = new File([blob], name, { type: blob.type });
          window.dispatchEvent(new CustomEvent('tour:setImage', { detail: { file, blob, name } }));
        };

        const btn = document.querySelector('#auto-input');
        if (!btn) return;

        // ✅ 기존에 붙은 모든 핸들러 제거(Driver의 기본 next 포함 가능성) + 대체
        const clone = btn.cloneNode(true);
        btn.replaceWith(clone);

        let running = false; // 재진입 가드

        const run = async (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (running) return;          // 이미 실행 중이면 무시
          running = true;

          // UI 잠금
          const prevText = clone.textContent;
          clone.disabled = true;
          clone.classList.add('is-busy');

          try {
            await sleep(50);
            await setDemoImage(demoImgUrl);
            await typeInto($name,    '창고 입구 스캐너', 10);
            await typeInto($urn,     'urn:epc:id:sgln:8808123456.21.0', 10);
            window.dispatchEvent(new CustomEvent('tour:setCountry', {
              detail: { code: 'KR', name: '대한민국' }
            }));
            await typeInto($memo,    '현관 근처, 내방객 안내 데스크 옆', 10);

            await sleep(1700);
            drv.moveNext();            // 완료 후 다음 스텝
          } finally {
            // 필요 시 다시 활성화 (다음 스텝으로 넘어가니 의미 없으면 생략 가능)
            clone.disabled = false;
            clone.textContent = prevText;
            clone.classList.remove('is-busy');
            running = false;
          }
        };

        // 한 개의 리스너만 등록
        clone.addEventListener('click', run);
      }
    },
    {
      element: () => q('[data-tour="dcreate.co2"]'),
      popover: {
        title: "탄소배출량 설정",
        side: "right",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li><b>슬라이더</b>를 드래그하여 원재료의 탄소배출량을 직접 조절할 수 있습니다.</li>
          <li><b>현재 값</b>은 kgCO₂e 단위로 표시되며, 기본 범위는 0 ~ 50kgCO₂e 입니다.</li>
          <li><b>색상 구간</b>은 배출량 수준을 의미합니다. (녹색=낮음, 노랑=보통, 빨강=높음)</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dcreate.co2"]'),
    },
    {
      element: () => q('[data-tour="dcreate.save"]'),
      popover: {
        title: "저장하기",
        side: "top",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li>해당 내용으로 데이터를 <b>저장</b>합니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dcreate.save"]'),
    },
    {
      element: null,
      popover: {
        title: "다음 가이드로 이동",
        side: "center",
        align: "center",
        description: `
          <div style="margin-bottom:32px;"><b>제품정보 등록메뉴</b>로 이동하시겠어요?</div>
          <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:center;">
            <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
            <button id="go-register" class="driver-popover-next-btn driver-popover-btn">
              이동
            </button>
          </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();
        document.querySelector('#go-register')
          ?.addEventListener('click', () => {
            drv.destroy();
            router.push({ name: 'Products' ,query: { tour: 'true' } });
          });
      }
    },
  ];
}
